/* eslint-disable */
export default {
  currentCall: 'Chiamata corrente',
  viewCalls: 'Visualizza chiamate',
  view: 'Visualizza',
  incomingCall: '{numberOf} chiamata in entrata',
  incomingCalls: '{numberOf} chiamate in entrata',
  callOnHold: '{numberOf} chiamata in attesa',
  callsOnHold: '{numberOf} chiamate in attesa',
  otherDeviceCall: '{numberOf} chiamata su altri dispositivi',
  otherDeviceCalls: '{numberOf} chiamate su altri dispositivi',
} as const;

// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"viewCalls"@#@ @source: @#@"View Calls"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"incomingCall"@#@ @source: @#@"{numberOf} Incoming Call"@#@
// @key: @#@"incomingCalls"@#@ @source: @#@"{numberOf} Incoming Calls"@#@
// @key: @#@"callOnHold"@#@ @source: @#@"{numberOf} Call On Hold"@#@
// @key: @#@"callsOnHold"@#@ @source: @#@"{numberOf} Calls On Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"{numberOf} Call on other devices"@#@
// @key: @#@"otherDeviceCalls"@#@ @source: @#@"{numberOf} Calls on other devices"@#@
